/** Board is GRID_SIZE × GRID_SIZE cells. */
export const GRID_SIZE = 9;

/** Board units per cell. The SVG viewBox is expressed in these. */
export const CELL = 100;

/**
 * How far a wire reaches, in cells (Chebyshev).
 * This one number is the whole game: 1-wide water is crossable from either
 * bank, 2-wide lakes and doubled ranges are not.
 */
export const SPAN = 2;

/** Daily grid #1. */
export const EPOCH = { year: 2026, month: 0, day: 1 } as const;

/** Height of the sky band above the board — HUD strip plus headroom for the giants. */
export const SKY_BAND = 52;

/*
 * Salts for the day-seeded streams. The ambient world layer (§5, §8 item 6)
 * — birds, hawk, smoke curl, water glint — and the ground flora (terrain
 * art, §4: always visible, never animated) each mix the day number with a
 * distinct odd integer so they vary independently but reproduce for every
 * player on the same day.
 */
export const BIRDS_SALT = 0x9e3779b1;
export const HAWK_SALT = 0xa1b2c3d5;
export const SMOKE_SALT = 0x517cc1b7;
export const WATER_GLINT_SALT = 0x27d4eb2f;
export const WATER_RIPPLE_SALT = 0x94d049bb;
export const FLORA_SALT = 0x85ebca6b;
export const LAND_TONE_SALT = 0xc2b2ae3d;
